import { createFileRoute } from "@tanstack/react-router"

import { NewsArticleList } from "./-components/NewsArticleList"
import { newsroomHead } from "./-components/newsroom"
import { NewsroomPage } from "./-components/NewsroomPage"
import { loadNewsroomContent } from "./-data/content"

export const Route = createFileRoute("/_content/news/articles")({
  loader: () => loadNewsroomContent("articles"),
  staleTime: Infinity,
  preloadStaleTime: Infinity,
  head: () => newsroomHead("articles"),
  component: ArticlesPage,
})

function ArticlesPage() {
  const articles = Route.useLoaderData()

  return (
    <NewsroomPage category="articles">
      <NewsArticleList articles={articles} />
    </NewsroomPage>
  )
}
